import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import {
  CURRENT_TICKET_OR_CASE_NUMBER,
  CURRENT_VAR_TICKET_OR_CASE_NUMBER,
} from "../constants";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";

export const getTicketOrCaseNumberDefault = createAction<string | null>(
  "current/getTicketOrCaseNumberDefault",
);

export const getTicketOrCaseNumber = createAction<string>(
  "current/getTicketOrCaseNumber",
);

export interface UpdateCurrentCtrArg {
  instanceId: string | null | undefined;
  contactId: string | null | undefined;
  ticketOrCaseNumberValue: string;
}

export const updateCurrentCtr = createAsyncThunk<
  AxiosResponse | undefined,
  UpdateCurrentCtrArg
>(
  "current/updateCurrentCtr",
  async ({
    instanceId,
    contactId,
    ticketOrCaseNumberValue,
  }: UpdateCurrentCtrArg) => {
    try {
      const response = await awsClientGateway({
        pathTemplate: `/connectApis/${instanceId}/${contactId}?apiName=contact-attributes`,
        method: "POST",
        body: {
          [CURRENT_TICKET_OR_CASE_NUMBER]: ticketOrCaseNumberValue,
          [CURRENT_VAR_TICKET_OR_CASE_NUMBER]: ticketOrCaseNumberValue,
        },
      });
      if (!response) {
        throw new Error("updateCurrentCtr API reponse error");
      }
      return response;
    } catch (error) {
      clientLog({
        component: `current`,
        message: `Something went wrong in updateCurrentCtr API => ${error}`,
      });
      logMessage(
        `current`,
        `Something went wrong in updateCurrentCtr API => ${error}`,
        `error`,
      );
      return undefined;
    }
  },
);

export interface SaveContactToHistoryPayload {
  history: boolean;
  historyData: Record<string, unknown> | null;
}
export const saveContactToHistoryAction =
  createAction<SaveContactToHistoryPayload>("current/saveContactToHistory");

export const setTicketValidation = createAction<boolean>(
  "current/ticketValidation",
);

export interface ResetStatePayload {
  defaultValue: string;
}
export const resetState = createAction<ResetStatePayload>("current/resetState");
